"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CurrentPageNamePrebind = (function () {
    function CurrentPageNamePrebind() {
        this.name = "currentPageName";
    }
    CurrentPageNamePrebind.prototype.getPrebind = function (args) {
        return function (pageName, element) {
            return pageName || args.context.scPageName;
        };
    };
    return CurrentPageNamePrebind;
}());
exports.CurrentPageNamePrebind = CurrentPageNamePrebind;



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/prebinding/prebindHelpers/CurrentPageName.ts
// module id = 39
// module chunks = 13 14